import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import React, { useEffect, useMemo, useRef, useState } from 'react'
import TextField from '@mui/material/TextField';
import { useTheme } from '@emotion/react';
import { useNavigate, useParams } from 'react-router-dom';
import FormPageHeader from '../utilities/FormPageHeader';
import { countryToAlpha2 } from 'country-to-iso';
import countryList from 'react-select-country-list';
import Select from 'react-select';
import { FormControl, Stack, Typography } from '@mui/material';
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import * as Flags from 'country-flag-icons/react/3x2';
import customStyles from 'app/shared-components/SelectCustomStyle';

const CountryForm = () => {

    const countryURL = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.country}`;
    const terriroryURL = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.territory}`;

    const [tabValue, setTabValue] = useState(0);
    const { id } = useParams();
    const formRef = useRef(null);
    const navigate = useNavigate();
    const [error, setError] = useState("");
    const [isNavigate, setIsNavigate] = useState(false);
    const [countryOptions, setCountryOptions] = useState();
    const [isDisabled, setIsdisabled] = useState(false);
    const [validError, setValidError] = useState({});
    const [checksubmit, setCheckSubmit] = useState(false);
    const [countryName, setCountryName] = useState("");
    const [territory, setTerritory] = useState("");
    const [territoryLink, setTerritoryLink] = useState("");
    const [territoryOptions, setTerritoryOptions] = useState([]);
    const [isoCode, setIsoCode] = useState("");
    const [snackState, setSnackState] = useState(false);
    const [successMsg, setSuccessMsg] = useState();
    const [editData, setEditData] = useState();
    const [hideDelete, setHideDelete] = useState(true)
    const [saveDisable, setSaveDisable] = useState(true)
    const handleSubmit = async () => {
        setCheckSubmit(true)
        let model = {
            isoCode: isoCode,
            name: countryName,
            territory: territoryLink
        };

        try {
            if (id) {
                if (countryName && !validError.countryName) {
                    await OAuthService.updateData(countryURL, id, model);
                    setSuccessMsg("Data Updated Successfully")
                    setSnackState(true);
                    setTimeout(() => { navigate('/countries') }, 800);
                }
            } else {
                if (countryName && !validError.countryName) {
                    await OAuthService.addData(countryURL, model);
                    setSuccessMsg("Data saved Successfully")
                    setSnackState(true);
                    setTimeout(() => { navigate('/countries') }, 800);
                }
            }

        } catch (error) {
            setError(error.message)
            return;
        }

    }

    const editCountryData = async () => {
        try {
            if (id) {
                const result = await OAuthService.getEditData(countryURL, id);
                const country = result?.data;
                setCountryName(country.name)
                setIsoCode(country.isoCode)
                const terriroryURL =  `${countryURL}/${id}/territory`;
                const territoryResponce = await OAuthService.getList(terriroryURL);
                const territory = territoryResponce.data;
                setTerritory(territory.displayName);
                const territoryLink = `${terriroryURL}/${territory.id}`
                setTerritoryLink(territoryLink);
                country.territory = territory.displayName;
                setEditData(country)
            }
        } catch (e) {
            console.log(e);
        }
    }

    useEffect(() => {
        if (id) {
            editCountryData();
            setHideDelete(false)
        }
    }, [])

    const handleDelete = async () => {

        try {
            if (id) {
                await OAuthService.deleteData(countryURL, id);
                setSuccessMsg("Data deleted Successfully")
                setSnackState(true);
                setTimeout(() => { navigate('/countries') }, 800);
            }

        } catch (error) {
            console.log("error", error);
            setError(error.message);
        }
    }


    useEffect(() => {
        const country = async () => {
            const options = countryList().getData();
            const result = options?.map((option) => {
                const Flag = Flags[option.value];
                return { label: option?.label, value: option?.label, code: option?.value, icon: option?.value && <Flag width={18} style={{ marginInline: "5px" }} /> }
            })
            setCountryOptions(result);
        }
        country();
    }, [])
    useEffect(() => {
        const territories = async () => {
            const territories = await OAuthService.getList(terriroryURL);

            const result = territories?.data?._embedded.territories.map((value) => {
                const territoryLink = `${terriroryURL}/${value.id}`
                console.log('territoryLink', territoryLink)
                console.log('value?._links?.territory?.href', value?._links?.territory?.href)
                return { label: value.displayName, value: value.displayName, id: value?.id, _link: territoryLink }
            })
            setTerritoryOptions(result);
        }
        territories();
    }, []);


    const handleCountryChange = (data) => {
        setCountryName(data.value);
        setIsoCode(data.code)
        checkDuplicateCountry(data.code)
    };

    const checkDuplicateCountry = async(code) => {
        try{
            const country = await OAuthService.getList(countryURL + '/search/findByIsoCode?isoCode='+code);
            if(country?.data && country?.data?.id !== id){
               
                    setValidError({...validError, countryName: 'This country already exist'})
                    setSaveDisable(true)
            }else{
                setValidError({...validError, countryName: ''})
            }

        }catch(error){
            setValidError({...validError, countryName: ''})
        }
    }
    const handleTerritoryChange = (data) => {
        setTerritory(data.value);
        setTerritoryLink(data._link);
    };

    isNavigate ? navigate("/countries") : ""

    const handleCancel = () => {
        navigate("/countries")
    }

    useEffect(() => {
        if (countryName ) {
            if(editData){
                if(editData.name !== countryName ){
                    setSaveDisable(false);
                }else{
                    setSaveDisable(true);
                }
            }else{
                setSaveDisable(false);
            }
        } else {
            setSaveDisable(true);
        }
    },[countryName]);

    return (
        <div className='w-full overflow-scroll'>
            <FormPageHeader
                componentName="Country"
                handleDelete={handleDelete}
                handleSubmit={handleSubmit}
                breadCrumbSeperator=">"
                successMsg={successMsg}
                snackState={snackState}
                currentPage={id ? "Update Country" : "Add Country"}
                parentBreadcrumbData={[{ pageName: 'Country List', pageLink: '/countries' }]}
                error={error}
                hideDelete={hideDelete}
                saveDisable={saveDisable}
                handleCancel={handleCancel}
            >

                <Tabs
                    value={tabValue}
                    indicatorColor="secondary"
                    textColor="inherit"
                    variant="scrollable"
                    scrollButtons="auto"
                    classes={{ root: 'w-full h-64 border-b-1' }}
                >
                    <Tab className="h-64" label="Basic Info" sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} />
                </Tabs>
            </FormPageHeader>
            <div className="p-16 sm:p-24 max-w-3xl">
                <FormControl
                    ref={formRef}
                    className="flex flex-col justify-center"
                >
                    <div className="">

                        <Stack>
                            <label>*ISO Code</label>
                            <TextField
                                className="mb-16"
                                type="text"
                                name="isoCode"
                                value={isoCode}
                                required
                                disabled
                                sx={{ 
                                    backgroundColor: 'action.disabledBackground',
                                    "& .MuiInputBase-input.Mui-disabled": {
                                        WebkitTextFillColor: (theme) => theme.palette.text.primary,
                                    }
                                }}
                                variant="outlined"
                            />
                        </Stack>
                        <Stack className="mb-16">
                            <label>*Country Name</label>
                            <Select name="country"
                                // placeholder="Select Country"
                                value={(countryOptions && countryName) && countryOptions.filter(obj => countryName.includes(obj.value))}
                                onChange={handleCountryChange}
                                className="select"
                                classNamePrefix="select"
                                options={countryOptions}
                                getOptionLabel={e => (
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        {e.icon}
                                        <span style={{ marginLeft: 5 }}>{e.label}</span>
                                    </div>
                                )}
                                styles={customStyles(((checksubmit && !countryName) || validError.countryName) && "#f44336")}
                            />
                            <Typography className="text-[#f44336] text-sm ml-14">{(checksubmit && !countryName) ? "This field is required" : validError.countryName}</Typography>
                        </Stack>

                        <Stack className="mb-96">
                            <label>Territories</label>
                            <Select
                                name="territory"
                                value={(territory && territoryOptions) && territoryOptions.filter(obj => territory.includes(obj.value))}
                                onChange={handleTerritoryChange}
                                options={territoryOptions}
                                getOptionLabel={e => (
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        {e.icon}
                                        <span style={{ marginLeft: 5 }}>{e.label}</span>
                                    </div>
                                )}
                                styles={customStyles()}
                            />
                            {/* <Typography className="text-[#f44336] text-sm ml-14">{(checksubmit && !territory) ? "This field is required" : validError.territory}</Typography> */}
                        </Stack>
                        

                    </div>

                </FormControl>
            </div>
        </div >
    )
}

export default CountryForm